export interface GridCell<T> {
  row: number;
  col: number;
  item: T;
}

function occupyKey(row: number, col: number): string {
  return `${row},${col}`;
}

export function walkHtmlTableCells(
  table: HTMLTableElement,
): GridCell<HTMLTableCellElement>[] {
  const result: GridCell<HTMLTableCellElement>[] = [];
  const occupied = new Set<string>();
  const rows = Array.from(table.querySelectorAll("tr"));

  rows.forEach((tr, rowIndex) => {
    let colIndex = 0;
    const cells = Array.from(tr.children).filter(
      (node): node is HTMLTableCellElement =>
        node instanceof HTMLTableCellElement,
    );

    for (const cell of cells) {
      while (occupied.has(occupyKey(rowIndex, colIndex))) colIndex++;

      result.push({ row: rowIndex, col: colIndex, item: cell });

      const colSpan = cell.colSpan || 1;
      const rowSpan = cell.rowSpan || 1;
      for (let dr = 0; dr < rowSpan; dr++) {
        for (let dc = 0; dc < colSpan; dc++) {
          if (dr || dc) occupied.add(occupyKey(rowIndex + dr, colIndex + dc));
        }
      }
      colIndex += colSpan;
    }
  });

  return result;
}

export function flattenOoxmlCellsFromTable(
  table: { rows: { cells: import("../ooxml/tableCore").OoxmlTableCellMeta[] }[] },
): import("../ooxml/tableCore").OoxmlTableCellMeta[] {
  return table.rows.flatMap((row) => row.cells);
}
